import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  card: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.events.grayShade2,
    borderRadius: "5px",
    border: `1px solid ${theme.palette.events.grayShade1}`,
    padding: `${theme.spacing(2.5)} ${theme.spacing(5)}`,
    boxShadow: "4px 4px 4px 0px #0C38911A",
    width: "100%",
  },
  cardInner: {
    display: "flex",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  textContainer: {
    width: "auto",
  },
  startFreeTrialButton: {
    width: "177px",
    marginLeft: "auto",
    [theme.breakpoints.down("lg")]: {
      marginLeft: "unset",
      marginTop: theme.spacing(2.5),
    },
  },
  title: {
    marginBottom: 5,
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  subtitle: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  scrollDown: {
    fontStyle: "italic",
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
}));
